import React, { useState } from "react";
import { Link } from "react-router-dom";
import CartDropdown from "./CartDropdown";
import { useTranslation } from "../../../context/TranslationsProvider";
import {useCart} from "../../../context/CartContext";

const Header: React.FC = () => {

    const [isCartOpen, setIsCartOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { cart } = useCart();

    const { translate, language, setLanguage } = useTranslation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="flex justify-center bg-black">
            <header className="flex justify-between items-center py-4 container mx-auto px-4 relative w-full">
                <div className="lg:hidden flex items-center">
                    <button onClick={toggleMenu} className="header-btn">
                        <img src="/assets/icons/menu.svg" alt="Menu" className="w-8 h-8" />
                    </button>
                </div>
                <div className="hidden lg:flex space-x-5">
                    <Link to="/">
                        <button className="block w-full text-left p-4 header-btn">
                            {translate('header_home')}
                        </button>
                    </Link>
                    <Link to="/all-paintings">
                        <button className="block w-full text-left p-4 header-btn">
                            {translate('header_collection')}
                        </button>
                    </Link>
                    <Link to="/about-me">
                        <button className="block w-full text-left p-4 header-btn">
                            {translate('header_about_me')}
                        </button>
                    </Link>
                </div>

                <div className="absolute left-1/2 transform -translate-x-1/2">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                        alt="Logo"
                        className="h-10 w-auto object-contain"
                    />
                </div>

                <div className="flex space-x-5 items-center ml-auto">
                    <div className="flex space-x-5 items-center">
                        <div
                            className="relative flex items-center"
                            onMouseEnter={() => setIsCartOpen(true)}
                            onMouseLeave={() => setIsCartOpen(false)}
                        >
                            <Link to="/cart">
                                <div className="p-2 cursor-pointer relative">
                                    <img
                                        src="/assets/icons/cart.svg"
                                        alt="CartDropdown"
                                        className="cart-icon w-6 h-6"
                                    />

                                    {cart.length > 0 && (
                                        <h3 className="absolute text-black h-[18px] aspect-square flex items-center justify-center top-0 text-sm -right-0.5 bg-orange-100 rounded-full p-1 border border-black">
                                            {cart.length}
                                        </h3>
                                    )}
                                </div>
                            </Link>
                            {isCartOpen && <CartDropdown />}
                        </div>
                    </div>
                    <div className="hidden lg:flex space-x-2">
                        <button onClick={() => setLanguage("eng")} className={language === 'eng' ? 'underline header-btn' : 'header-btn'}>
                            EN
                        </button>
                        <button onClick={() => setLanguage("lv")} className={language === 'lv' ? 'underline header-btn' : 'header-btn'}>
                            LV
                        </button>
                        <button onClick={() => setLanguage("ru")} className={language === 'ru' ? 'underline header-btn' : 'header-btn'}>
                            RU
                        </button>
                    </div>
                </div>

                {isMenuOpen && (
                    <div className="absolute top-16 left-0 bg-black z-50 transition-all w-screen sm:w-1/2 sm:left-0">
                        <Link to="/">
                            <button className="block w-full text-left p-4 header-btn">
                                {translate('header_home')}
                            </button>
                        </Link>
                        <Link to="/all-paintings">
                            <button className="block w-full text-left p-4 header-btn">
                                {translate('header_collection')}
                            </button>
                        </Link>
                        <Link to="/about-me">
                            <button className="block w-full text-left p-4 header-btn">
                                {translate('header_about_me')}
                            </button>
                        </Link>
                        <div className="flex justify-center space-x-2 p-4">
                            <button onClick={() => setLanguage("eng")} className="header-btn">
                                EN
                            </button>
                            <button onClick={() => setLanguage("lv")} className="header-btn">
                                LV
                            </button>
                            <button onClick={() => setLanguage("ru")} className="header-btn">
                                RU
                            </button>
                        </div>
                    </div>
                )}
            </header>
        </div>
    );
};

export default Header;